<i18n lang='yml' src='../i18n/AssetList.yml'></i18n>
<template>
  <div class="col-sm-12">
      <div v-if="edit == 'false'" class="select-assets">
      <ul class="list-inline list-annotation">
        <li class="list-inline-item">
          <a :href="selectedAssets.length == 0 ? '#': `/en/assets/download_zip?selected_assets=[${selectedAssets}]` " 
            :aria-label="$t('download_zip')" 
            :class="[{disabled: selectedAssets.length == 0 }, 'btn', 'btn-outline-success', 'btn-sm', ' mt-1', 'mb-0']"
          >
            <span v-if="selectedAssets.length == 0">
              <font-awesome-icon :icon="['far', 'download']"/>
              {{$t('no_assets')}}
            </span>
            <span v-else>
              <font-awesome-icon :icon="['fas', 'download']"/>
               {{$t('download_assets', {count: selectedAssets.length})}}
            </span>
          </a>
        </li>
        <li class="list-inline-item ml-auto pb-0">
          <button @click="selectAllAssets" :class="[{active: selectedAssets.length ==  assetList.length}, 'btn', 'btn-outline-success', 'btn-sm', ' mt-1', 'mb-0']">
            {{$t('select_all')}}
          </button>
        </li>
        <li class="list-inline-item pb-0">
          <button @click="deselectAllAssets" class="btn btn-outline-success btn-sm mt-1 mb-0">
            {{$t('deselect_all')}}
          </button>
        </li>
      </ul>
    </div>
    <div class="row">
      <asset-template @selected="handleAssets" :key="asset.id" v-for="asset in assetList" :asset="asset" :no_preview_path="no_preview_path" :edit="edit" :selected_assets="selectedAssets" :public_page="public_page"/>
    </div>
  </div>
</template>
<script>
import assetTemplate from './Asset.vue';

export default {
  components: {
      'asset-template': assetTemplate
  },
  props: ['assets', 'locale', 'no_preview_path', 'edit', 'public_page'],

  data() {
    return {
      assetList: [],
      selectedAssets: [],
      error: false,
    }
  },
  mounted() {
    try {
      this.assetList = JSON.parse(this.assets) || [];
    }
    catch(err) {
      this.error = true
    }
  },

  methods: {
    handleAssets(id, select_only=false, deselect_only=false) {
      let index = this.selectedAssets.indexOf(id)
      if(index != -1 && !select_only) {
        this.selectedAssets.splice(index, 1) 
      }
      else if(!deselect_only) {
         if (!this.selectedAssets.includes(id)) {
            this.selectedAssets.push(id)
         }
      }
    },
    selectAllAssets() {  
      const _vm = this
      this.assetList.forEach((asset) => {
        _vm.handleAssets(asset.id, true, false)
      })
    },
    deselectAllAssets() {
      const _vm = this
      this.assetList.forEach((asset) => {
        _vm.handleAssets(asset.id, false, true)
      })
    },

    downloadAllAssets() {
       this.selectedAssets = []
    }
  }
}
</script>
